export default "__VITE_ASSET__CHUOmas0__"